import { render, staticRenderFns } from "./BulkAddBoardsModal.vue?vue&type=template&id=1d68cb0a"
import script from "./BulkAddBoardsModal.vue?vue&type=script&lang=js"
export * from "./BulkAddBoardsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports